(function () {
  var ticking = false;
  var scrollTicking = false;
  var lastDirectionScrollY = 0;
  var DESKTOP_BREAKPOINT = 1025;
  var HIDE_AFTER_PX = 24;
  var DIRECTION_DELTA_PX = 4;

  function getHeader() {
    return document.querySelector("[data-cd-hero-header]");
  }

  function getAnnouncementBar() {
    return document.querySelector(
      "#shopify-section-announcement-bar .t4s-announcement-bar",
    );
  }

  function updateHeaderHeight(header) {
    if (!header) return;

    var rect = header.getBoundingClientRect();
    var height = Math.max(0, rect.height, header.offsetHeight || 0);

    document.documentElement.style.setProperty(
      "--cd-home-header-height",
      Math.round(height) + "px",
    );
  }

  function updateAnnouncementOffset() {
    var announcement = getAnnouncementBar();
    var visibleHeight = 0;

    if (
      announcement &&
      announcement.getAttribute("aria-hidden") !== "true" &&
      !announcement.classList.contains("t4s-d-none") &&
      announcement.getClientRects().length
    ) {
      var rect = announcement.getBoundingClientRect();
      visibleHeight = Math.max(
        0,
        Math.min(window.innerHeight || document.documentElement.clientHeight, rect.bottom),
      );
    }

    document.documentElement.style.setProperty(
      "--cd-announcement-visible-height",
      Math.round(visibleHeight) + "px",
    );
  }

  function getCandidates() {
    return Array.prototype.slice.call(
      document.querySelectorAll(
        "[data-cd-header-scheme], [data-cd-header-scheme-mobile]",
      ),
    );
  }

  function getSchemeForSection(section) {
    if (!section) return "dark";
    var mobile = window.innerWidth < DESKTOP_BREAKPOINT;
    var scheme = mobile
      ? section.getAttribute("data-cd-header-scheme-mobile") ||
        section.getAttribute("data-cd-header-scheme")
      : section.getAttribute("data-cd-header-scheme") ||
        section.getAttribute("data-cd-header-scheme-mobile");
    return scheme === "light" ? "light" : "dark";
  }

  function closestSchemeElement(node) {
    while (node && node !== document.documentElement) {
      if (
        node.nodeType === 1 &&
        (node.hasAttribute("data-cd-header-scheme") ||
          node.hasAttribute("data-cd-header-scheme-mobile"))
      ) {
        return node;
      }
      node = node.parentElement;
    }
    return null;
  }

  function findByElementsFromPoint(header) {
    if (typeof document.elementsFromPoint !== "function") return null;

    var rect = header.getBoundingClientRect();
    var probeYs = [0.2, 0.5, 0.8].map(function (ratio) {
      return Math.max(
        0,
        Math.min(
          window.innerHeight - 1,
          Math.round(rect.top + rect.height * ratio),
        ),
      );
    });
    var probeXs = [0.18, 0.5, 0.82].map(function (ratio) {
      return Math.max(
        0,
        Math.min(window.innerWidth - 1, Math.round(window.innerWidth * ratio)),
      );
    });

    for (var y = 0; y < probeYs.length; y += 1) {
      for (var x = 0; x < probeXs.length; x += 1) {
        var stack = document.elementsFromPoint(probeXs[x], probeYs[y]);
        for (var i = 0; i < stack.length; i += 1) {
          var candidate = closestSchemeElement(stack[i]);
          if (candidate) return candidate;
        }
      }
    }

    return null;
  }

  function findByGeometry(header) {
    var candidates = getCandidates();
    if (!candidates.length) return null;

    var rect = header.getBoundingClientRect();
    var probeTop = Math.max(0, Math.min(window.innerHeight - 1, rect.top + 1));
    var probeBottom = Math.max(
      0,
      Math.min(window.innerHeight - 1, rect.bottom - 1),
    );
    var active = null;

    for (var i = 0; i < candidates.length; i += 1) {
      var candidateRect = candidates[i].getBoundingClientRect();
      var overlapsHeader =
        candidateRect.top <= probeBottom && candidateRect.bottom >= probeTop;
      if (overlapsHeader) {
        active = candidates[i];
      }
    }

    if (active) return active;

    var closest = null;
    var closestDistance = Infinity;
    var probeMid = (probeTop + probeBottom) / 2;

    for (var j = 0; j < candidates.length; j += 1) {
      var rect2 = candidates[j].getBoundingClientRect();
      var distance = Math.min(
        Math.abs(rect2.top - probeMid),
        Math.abs(rect2.bottom - probeMid),
      );
      if (distance < closestDistance) {
        closestDistance = distance;
        closest = candidates[j];
      }
    }

    return closest;
  }

  function isSurfaceDrivenHome() {
    return document.body.classList.contains('template-index') &&
      document.documentElement.classList.contains('cd-home-surface-ready') &&
      document.querySelector('[data-cd-surface-start]');
  }

  function isSurfaceDrivenPdp() {
    return document.body.classList.contains('template-product') &&
      document.documentElement.classList.contains('cd-pdp-surface-ready') &&
      document.querySelector('[data-cd-pdp-surface-start]');
  }

  function applyScheme(header, scheme) {
    var isLight = scheme === "light";
    header.classList.toggle("is-scheme-light", isLight);
    header.classList.toggle("is-scheme-dark", !isLight);
    document.documentElement.classList.toggle(
      "cd-header-scheme-light",
      isLight,
    );
    document.documentElement.classList.toggle(
      "cd-header-scheme-dark",
      !isLight,
    );
  }

  function updateHeaderScheme() {
    var header = getHeader();
    if (!header) {
      ticking = false;
      return;
    }

    if (isSurfaceDrivenHome() || isSurfaceDrivenPdp()) {
      ticking = false;
      return;
    }

    var active = findByElementsFromPoint(header) || findByGeometry(header);
    applyScheme(header, getSchemeForSection(active));
    ticking = false;
  }

  function queueUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateHeaderScheme);
  }

  function getHeaderOptions(header) {
    try {
      return JSON.parse(header.getAttribute("data-header-options") || "{}");
    } catch (error) {
      return {};
    }
  }

  function hasOpenOverlay() {
    return Boolean(
      document.documentElement.classList.contains("cd-shop-menu-open") ||
        document.body.classList.contains("cd-shop-menu-open") ||
      document.documentElement.classList.contains("is--opend-drawer") ||
        document.body.classList.contains("is--opend-drawer") ||
        document.querySelector('.t4s-drawer[aria-hidden="false"], .mfp-wrap.mfp-ready'),
    );
  }

  function setHeaderVisibility(isVisible) {
    document.documentElement.classList.toggle("cd-hero-header-visible", isVisible);
    document.documentElement.classList.toggle("cd-hero-header-hidden", !isVisible);
  }

  function updateScrollReveal() {
    var header = getHeader();
    if (!header) {
      scrollTicking = false;
      return;
    }

    updateHeaderHeight(header);
    updateAnnouncementOffset();

    var options = getHeaderOptions(header);
    if (!options.isSticky || !options.hideScroldown) {
      document.documentElement.classList.remove(
        "cd-hero-header-scroll-ready",
        "cd-hero-header-visible",
        "cd-hero-header-hidden",
      );
      scrollTicking = false;
      return;
    }

    var currentScrollY = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
    var delta = currentScrollY - lastDirectionScrollY;
    var shouldShow = currentScrollY <= HIDE_AFTER_PX || hasOpenOverlay();

    document.documentElement.classList.add("cd-hero-header-scroll-ready");
    document.documentElement.classList.toggle("is-header--stuck", currentScrollY > 2);

    if (!shouldShow && Math.abs(delta) >= DIRECTION_DELTA_PX) {
      shouldShow = delta < 0;
      lastDirectionScrollY = currentScrollY;
    } else if (shouldShow) {
      lastDirectionScrollY = currentScrollY;
    } else {
      shouldShow = !document.documentElement.classList.contains("cd-hero-header-hidden");
    }

    setHeaderVisibility(shouldShow);
    scrollTicking = false;
  }

  function queueScrollReveal() {
    if (scrollTicking) return;
    scrollTicking = true;
    window.requestAnimationFrame(updateScrollReveal);
  }

  function init() {
    if (!getHeader()) return;
    lastDirectionScrollY = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
    updateAnnouncementOffset();
    queueUpdate();
    queueScrollReveal();
    setTimeout(queueUpdate, 60);
    setTimeout(queueUpdate, 220);
    setTimeout(queueUpdate, 700);
    setTimeout(queueScrollReveal, 60);
    setTimeout(queueScrollReveal, 220);
    setTimeout(queueScrollReveal, 700);

    var announcement = getAnnouncementBar();
    var header = getHeader();

    if (header && typeof ResizeObserver === "function") {
      new ResizeObserver(queueScrollReveal).observe(header);
    }

    if (announcement) {
      if (typeof ResizeObserver === "function") {
        new ResizeObserver(queueScrollReveal).observe(announcement);
      }
      if (typeof MutationObserver === "function") {
        new MutationObserver(queueScrollReveal).observe(announcement, {
          attributes: true,
          attributeFilter: ["aria-hidden", "class", "style"],
        });
      }
    }
  }

  document.addEventListener("DOMContentLoaded", init);
  window.addEventListener("load", queueUpdate);
  window.addEventListener("load", queueScrollReveal);
  window.addEventListener("scroll", queueUpdate, { passive: true });
  window.addEventListener("scroll", queueScrollReveal, { passive: true });
  window.addEventListener("resize", queueUpdate);
  window.addEventListener("resize", queueScrollReveal);
  window.addEventListener("orientationchange", queueUpdate);
  window.addEventListener("orientationchange", queueScrollReveal);
  document.addEventListener("shopify:section:load", queueUpdate);
  document.addEventListener("shopify:section:load", queueScrollReveal);
  document.addEventListener("shopify:section:reorder", queueUpdate);
  document.addEventListener("shopify:section:reorder", queueScrollReveal);

  window.CDCleerHeaderTheme = {
    refresh: queueUpdate,
    refreshScrollReveal: queueScrollReveal,
  };
})();
